import Fireflies from './Fireflies';
import CyberLeaf from './CyberLeaf';

const ForestAesthetics = () => {
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        pointerEvents: 'none', // Allows clicking through to content
        zIndex: -1, // Sits behind all other content
      }}
      aria-hidden="true"
    >
      {/* Layer 1: Ambient Particles */}
      <Fireflies />

      {/* Layer 2: Animated SVG Actors */}
      <CyberLeaf
        style={{
          position: 'absolute',
          bottom: '5vh',
          right: '5vw',
          opacity: 0.8,
        }}
      />
      <CyberLeaf
        style={{
          position: 'absolute',
          top: '10vh',
          left: '2vw',
          width: '100px',
          opacity: 0.6,
          transform: 'scaleX(-1) rotate(20deg)', // Flip and rotate for variation
        }}
      />
    </div>
  );
};

export default ForestAesthetics;
